import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducers from "./reducers/rootReducer";
import rootSaga from "./sagas/rootSaga";

// Create Saga Middleware
const sagaMiddleware = createSagaMiddleware();

// Configure Store
export const store = configureStore({
    reducer: rootReducers, // Root reducers
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: false,
            serializableCheck: false,
        }).concat(sagaMiddleware),
});

// Run Saga Middleware
sagaMiddleware.run(rootSaga);
